import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import ScheduleModal from "../components/scheduleModal";
import { useParams, Link } from "react-router-dom";

const BillPassingHoView = () => {
  useAuthRedirect();
    const {grnNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [poDetail, setPoDetail] = useState({});
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);

  const [subDetails, setSubDetails] = useState({})

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/billHo_view?grnNo=${grnNo}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                grnheader_number: items[0].grnheader_number,
                grnheader_date: items[0].grnheader_date,
                grnHeader_poNumber: items[0].grnHeader_poNumber,
                grnHeader_poDate: items[0].grnHeader_poDate,
                supp: items[0].grnheader_suppliercode,
                dcNo: items[0].grnheader_DcNumber,
                dcDate: items[0].grnheader_DcDate,
                iNo: items[0].grnheader_invoiceNumber,
                iDate: items[0].grnheader_invoiceDate,
                subValue: items[0].grnHeader_value,
                disc: items[0].grnHeader_discount,
                pf: items[0].grnHeader_pfCharges,
                paymentTerms: items[0].grnHeader_paymentTerms,
                fright: items[0].grnHeader_freightCharges,
                transport: items[0].grnHeader_transport,
                gst: items[0].grnHeader_salesTax,
                delMethod: items[0].grnHeader_deliveryMethod,
                delPlace: items[0].grnHeader_deliveryPlace,
                priceBasis: items[0].grnHeader_priceBasis,
                remarks: items[0].grnHeader_remarks,
                grandTot: items[0].grnHeader_totalValue,
                
            };

            setPoDetail(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [grnNo]); 

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${poDetail.supp}`);
            const items = response.data.supDetails;
            console.log(response.data.supDetails);
            
            const storeReqHeaderCity = {
                supplierMaster_code : items[0].supplierMaster_code,
                supplierMaster_name : items[0].supplierMaster_name,
                supplierMaster_addressline1 : items[0].supplierMaster_addressline1,
                supplierMaster_addressline2 : items[0].supplierMaster_addressline2,
                supplierMaster_city : items[0].supplierMaster_city,
                supplierMaster_pincode : items[0].supplierMaster_pincode,
                
            };
            setSubDetails(storeReqHeaderCity);
            // setData(response.data.supDetails);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [poDetail.supp]); 



 const [loading, setLoading] = useState(true); // loading state

useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true); // start loading
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/billHo_viewDetails?grnNo=${grnNo}`
      );

      if (response.data && response.data.Details) {
        setData(response.data.Details);
        console.log(response.data.Details);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setLoading(false); // stop loading
    }
  };

  fetchData();
}, [grnNo]); 

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
            <div className="back-div">
                                            <h2 className="add-txt">Bill Passing GRN View</h2>
                                            <Link to='/inventory/billPassingGRNView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                            </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
          <div className="form-row">
              <div className="form-group">
                <label>GRN Number :</label>
                <input type="text" name="PoNumber" value={poDetail.grnheader_number} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.grnheader_date ? 
         new Date(poDetail.grnheader_date).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>P.O Number :</label>
                <input type="text" name="PoNumber" value={poDetail.grnHeader_poNumber} readOnly />
              </div>
              <div className="form-group">
                <label>P.O Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.grnHeader_poDate ? 
         new Date(poDetail.grnHeader_poDate).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>D.C No :</label>
                <input type="text" name="yourRefNo"   value={poDetail.dcNo} readOnly/>
              </div>
              <div className="form-group">
                <label>D.C Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.dcDate ? 
         new Date(poDetail.dcDate).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input type="text" name="ourRefNo" value={poDetail.iNo} readOnly />
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input type="text" name="endhrs"value={poDetail.iDate ? new Date(poDetail.iDate).toLocaleDateString("en-GB") : ""}readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1" value={subDetails.supplierMaster_addressline1} readOnly/>
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={subDetails.supplierMaster_addressline2} readOnly/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city" value={subDetails.supplierMaster_city} readOnly/>
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input type="text" name="pincode" value={subDetails.supplierMaster_pincode} readOnly/>
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Part No</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>GST%</th>
                    <th>PF%</th>
                    <th>Disc%</th>
                    <th>Value</th>
                    <th>Bill Passing by</th>
                  </tr>
                </thead>
      <tbody>
  {loading ? (
    <tr>
      <td colSpan="12" style={{ textAlign: "center", fontWeight: "bold" }}>
        Please wait, loading...
      </td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.grnDetail_itemcode}</td>
        <td>{item.grnDetail_itemName}</td>
        <td>{item.grnDetail_uom}</td>
        <td>{item.grnDetail_packedQuantity}</td>
        <td>{item.grnDetail_acceptedQuantity}</td>
        <td>{item.grnDetail_price}</td>
        <td>{item.grnDetail_taxPercentage}</td>
        <td>{item.grnDetail_pfPercentage}</td>
        <td>{item.grnDetail_discountPercentage}</td>
        <td>
          {new Intl.NumberFormat("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(item.grnDetail_value)}
        </td>
        <td>{item.grnDetail_billPassingBy}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="12" style={{ textAlign: "center" }}>
        No items
      </td>
    </tr>
  )}
</tbody>



              </table>
            </div>
                
          </form>
           
        </div>
         {/* Billing Summary */}
         <div className="po-bill-container">
                    <h2 className="po-bill-title">Billing Summary</h2>
                    <div className="po-bill-summary">
                    <div className="po-bill-item">
                        <span className="po-bill-label">Sub Total:</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.subValue)}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">GST (18%):</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.gst)}</span>

                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Disc (%):</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.disc)}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">PF:</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.pf)}</span>

                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Fright Charges:</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.fright)}</span>

                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Transport:</span>
                        <span className="po-bill-value">{poDetail.transport}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Payment Terms:</span>
                        <span className="po-bill-value">{poDetail.paymentTerms}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Delivery Method:</span>
                        <span className="po-bill-value">{poDetail.delMethod}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Delivery Place:</span>
                        <span className="po-bill-value">{poDetail.delPlace}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Price Basis:</span>
                        <span className="po-bill-value">{poDetail.priceBasis}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Remarks:</span>
                        <span className="po-bill-value">{poDetail.remarks}</span>
                    </div>
                  <div className="po-bill-item po-bill-total">
  <span className="po-bill-label">Total:</span>
<span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.grandTot)}</span>


</div>


                    </div>
              </div>
      </div>
      
    </div>
  );
};

export default BillPassingHoView;
